














import ApiService from "@/services/ApiService";
import Vue from "vue";

export default Vue.extend({
  name: "Header",
  data: function () {
    return { loggedIn: false };
  },
  watch: {
    $route() {
      this.checkLoginStatus();
    },
  },
  mounted() {
    this.checkLoginStatus();
  },
  methods: {
    async checkLoginStatus() {
      this.loggedIn = await ApiService.isLoggedIn();
    },
    onLogout() {
      ApiService.logout();
    },
  },
});
